export const TravelStoryElementFields = `
{
    title
    subtitle
    description
}
`;
